export enum LocationType {
    NightClub = 0, HighEnergyBar = 1, LowEnergyBar = 2, Restaurant = 3, WineMerchant = 4
}